<script setup lang="ts">
import {nextTick, onMounted, ref} from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number]
  },
  label: String,
  type: {
    type: String,
    default: 'text'
  },
  placeholder: String,
  error: String,
  inputClass: {
    type: String,
    default: 'design'
  },
  autoFocus: {
    type: Boolean,
    default: false
  },
  min: {
    type: [String, Number],
    default: undefined
  }
});

const formFocus = ref();

onMounted(() => {
  if (props.autoFocus) {
    nextTick().then(() => {
      formFocus.value.focus();
    });
  }
})

</script>

<template>
  <div>
    <label v-if="label" class="block mb-2 text-subtext">{{ label }}</label>
    <div class="relative">
      <div v-if="$slots.icon" class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
        <slot name="icon" />
      </div>
      <input
        :type="type"
        :value="modelValue"
        @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
        :class="[inputClass, $slots.icon ? 'with-icon' : 'without-icon']"
        :placeholder="placeholder"
        :min="min"
        ref="formFocus"
        @blur="$emit('blur')"
      />
    </div>
    <div class="pt-1 pb-1 text-red-500" v-if="error">{{ error }}</div>
  </div>
</template>


<style scoped>
.design {
  @apply bg-slate-800 border border-transparent focus:border-transparent focus:outline-none text-slate-300 rounded focus:ring-slate-700 focus:border-slate-700 block w-full pr-2 py-1.5;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.with-icon {
  @apply pl-10;
}

.without-icon {
  @apply pl-2;
}
</style>
